import { PrimeReactModal } from "@finanedi.es/storybook"
import { MODAL_STYLES } from "constants/primereactStyles"
import { useContactosContext } from "features/Contactos/context/ContactosProvider"
import EliminarContacto from "features/Contactos/pages/EliminarContacto"
import { useTranslation } from "react-i18next"
import useContactos from "../hooks/useContactos"
import CrearContacto from "../pages/CrearContacto"
import "./styles.scss"

const ContactosModals = () => {
  const { t } = useTranslation()
  const {
    // @ts-expect-error TS(2339): Property 'showDeleteContacto' does not exist on ty...
    showDeleteContacto,
    // @ts-expect-error TS(2339): Property 'selectedMultipleContactos' does not exis...
    selectedMultipleContactos,
    // @ts-expect-error TS(2339): Property 'showDeleteMultipleContactos' does not ex...
    showDeleteMultipleContactos,
  } = useContactosContext()

  const isMultiple = selectedMultipleContactos?.length > 1
  const {
    showCreateContactoModal,
    toggleShowCreateContacto,
    toggleIsContactCreatedDispatch,
    // @ts-expect-error TS(2554): Expected 1 arguments, but got 0.
  } = useContactos()

  return (
    <>
      <PrimeReactModal
        visible={showCreateContactoModal}
        className='tw-w-137.5 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
        baseZIndex={20}
        ptContext={MODAL_STYLES}
        closable={false}
        keepInViewport={false}
        header={t("contactos.crear.newContact")}
      >
        <CrearContacto
          isCliente
          onHide={toggleShowCreateContacto}
          toggleIsContactCreatedDispatch={toggleIsContactCreatedDispatch}
        />
      </PrimeReactModal>
      <PrimeReactModal
        visible={isMultiple ? showDeleteMultipleContactos : showDeleteContacto}
        className='tw-w-112 tw-rounded-lg tw-py-5 tw-px-6 tw-bg-white'
        baseZIndex={20}
        ptContext={MODAL_STYLES}
        closable={false}
      >
        <EliminarContacto />
      </PrimeReactModal>
    </>
  )
}

export default ContactosModals
